import styled from "styled-components";

const Content = styled.div`
  @media screen and (max-width: 960px) {
    padding: 0 20px;
    font-size: 14px;
  }
  @media screen and (min-width: 961px) {
    font-size: 16px;
  }
`;
export default Content;
